<!--
	@name app-firm-dialog-confirm-default
	@description A confirm dialog for firm default panel operations
	@date 2026/01/23
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<v-dialog v-model="dialog" max-width="500" :style="{ zIndex: 200 }" :persistent="loading" :component="$options.name">
		<v-card>
			<v-app-bar dark color="warning">
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				<v-spacer />
			</v-app-bar>

			<v-card-text v-if="message" class="pa-4">
				<p class="mb-0 text-subtitle-1">
					{{ message }}
				</p>
			</v-card-text>

			<v-card-text v-if="html" class="pa-4">
				<div class="mb-0 text-subtitle-1" v-html="$sanitize(html)" />
			</v-card-text>

			<v-card-actions class="pa-4">
				<v-spacer />
				<v-btn color="primary" class="mr-1" :loading="loading" :disabled="loading" @click.native="agree">
					OK
				</v-btn>
				<v-btn outlined color="blue-grey" :disabled="loading" @click.native="cancel">
					Cancel
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'app-firm-dialog-confirm-default',

		data() {
			return {
				dialog: false,
				loading: false,
				resolve: null,
				reject: null,
				title: null,
				message: null,
				html: false
			};
		},

		methods: {
			/**
			 * @name open
			 * @description Open the dialog
			 * @param {String} message The message for the dialog
			 * @return {Promise} A Promise
			 */
			open(title, message, html = false) {
				this.reset();
				this.dialog = true;
				this.title = title;
				this.message = message;
				this.html = html;

				return new Promise((resolve, reject) => {
					this.resolve = resolve;
					this.reject = reject;
				});
			},

			/**
			 * @name setLoading
			 * @description Set loading state
			 * @param {Boolean} state Loading state
			 */
			setLoading(state) {
				this.loading = state;
			},

			/**
			 * @name close
			 * @description Close the dialog
			 */
			close() {
				this.dialog = false;
				this.loading = false;
			},

			/**
			 * @name agree
			 * @description User clicked OK
			 */
			agree() {
				this.loading = true;
				this.resolve(true);
			},

			/**
			 * @name cancel
			 * @description User clicked Cancel
			 */
			cancel() {
				this.reject();
				this.dialog = false;
			},

			/**
			 * @name reset
			 * @description Reset dialog state
			 */
			reset() {
				this.dialog = false;
				this.loading = false;
				this.resolve = null;
				this.reject = null;
				this.title = null;
				this.message = null;
			}
		}
	};
</script>
